// @flow

import React from "react";
import { localize } from "redux-i18n";
import profileActionCreators from "@modules/profile/actionCreator";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Col,
  withFocusFirstInput,
} from "@components";
import { SchemaForm } from "@components";
import { uiSchema } from "./__ui__";
import { emailPattern } from "@utils/schema";

type ContactInfo = $Exact<{
  personalEmail: string | null,
  homePhone: string | null,
  mobilePhone: string | null,
}>;

type Props = $Exact<{
  contactInfo: ContactInfo,
  onDismissHandler: () => void,
  schema: Object,
  onSubmit: (form: Object) => void,
  ...PropsFromLocalize,
}>;

const ModalBodyWithFocus = withFocusFirstInput(ModalBody);

export class ContactInfoModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };
  validateSchema = (formData: Object, errors: Object) => {
    if (formData.personalEmail && !emailPattern.test(formData.personalEmail)) {
      errors.personalEmail.addError("Invalid email format");
    }

    return errors;
  };
  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("CONTACT_INFO")}
        </ModalHeader>
        <ModalBodyWithFocus>
          <Col sm={{ size: 8, offset: 2 }}>
            <SchemaForm
              ref={this.formRef}
              onSubmit={this.handleSubmit}
              uiSchema={uiSchema(this.props.t)}
              formData={this.props.contactInfo}
              schema={this.props.schema}
              validate={this.validateSchema}
              externalSubmit
            />
          </Col>
        </ModalBodyWithFocus>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" type="submit" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(withFocusFirstInput(ContactInfoModal));
